var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9582 12.7522C18.484 11.7851 19.8401 11.7851 20.3659 12.7522L24.8233 20.9507C25.3358 21.8934 24.6715 23.0539 23.6194 23.0539H14.7047C13.6526 23.0539 12.9883 21.8934 13.5008 20.9507L17.9582 12.7522ZM19.6485 13.9728C19.6485 13.7041 19.4307 13.4863 19.1621 13.4863C18.8934 13.4863 18.6756 13.7041 18.6756 13.9728V19.4863C18.6756 19.755 18.8934 19.9728 19.1621 19.9728C19.4307 19.9728 19.6485 19.755 19.6485 19.4863V13.9728ZM18.5134 21.4323C18.5134 21.7905 18.8038 22.0809 19.1621 22.0809C19.5203 22.0809 19.8107 21.7905 19.8107 21.4323C19.8107 21.074 19.5203 20.7836 19.1621 20.7836C18.8038 20.7836 18.5134 21.074 18.5134 21.4323Z",
    fill: "#F59D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3514 12.9998C24.3514 6.73061 19.2692 1.64844 13 1.64844C6.73085 1.64844 1.64868 6.73061 1.64868 12.9998C1.64868 19.269 6.73085 24.3511 13 24.3511",
    stroke: "#F59D0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 6V13.0001H7",
    stroke: "#F59D0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/Expired.9e9582805b843db6c97f4de636b1c160.svg";
export { ForwardRef as ReactComponent };